<template>
  <v-container fluid>
    <v-tabs grow @change="onTabChange" v-model="activeCartTab">
      <v-tabs-slider></v-tabs-slider>
      <v-tab href="#tab-cart-draft" @click="belumDibayar"> Belum Dibayar </v-tab>
      <v-tab href="#tab-cart-new" @click="menungguKiriman"> Menunggu Kiriman </v-tab>
    </v-tabs>
    
  </v-container>
</template>

<script>
import { mapActions, mapState } from "vuex";
export default {
  name: "TransactionList",
  data(){
    return {
      activeCartTab: null,
      new: "",
      orderNoSearch: '',
      tab: null,
        countData: 0,
        items: [
          'Belum Dibayar', 'Menunggu Kiriman', 'Lunas', 'Dibatalkan',
        ],
        text: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.',
    }
  },
  methods: {
    ...mapActions(["getTransactionList"]),
    async belumDibayar(){
      console.log("masuk pak eko");
    },
    async menungguKiriman(){
      this.getTransactionList({
      by: {
        pageNumber: 0,
        pageSize: 100,
        searchVal: "",
        status: "NEW",
      },
      isGroupedByStatus: true,
    })
      .then((response) => {
        if (this.transactionList !== null) {
          this.new = this.transactionList.new
        }
        this.$helpers.handleSuccess(response);
      })
      .catch((error) => {
        this.$helpers.handleError(error);
      });
    },
    onTabChange: function (clickedTab) {
      switch (clickedTab) {
        case "tab-cart-draft":
          break;
        case "tab-cart-new":
          break;
      }
    },
    transLabeling(trans) {
      let countTrans = Object.keys(trans).length;
      if (countTrans > 0) {
        return `${countTrans}`;
      } else {
        return `0`;
      }
    },
  },
  mounted() {
    // this.getTransactionListWaitingKiriman();

    switch (this.$route.params.cartStatus) {
      case "draft":
        this.activeCartTab = "tab-cart-draft";
        break;
      case "new":
        this.activeCartTab = "tab-cart-new";
        break;
      default:
        this.activeTransTab = "tab-cart-new";
        break;
    }
  },
  computed: {
    ...mapState(["transactionList"]),
  },
};
</script>

<style src="./TransactionList.scss" lang="scss"/>